import { getAuthSession } from '@/lib/_utils/supabase/client';
import { StateCreator } from 'zustand';
import { User } from '@supabase/supabase-js';


export type UserCurrency = {
	code: string;
	symbol: string;
	decimals: number;
};

const DEFAULT_USER_CURRENCY: Readonly<UserCurrency> = {
	code: 'USD',
	symbol: '$',
	decimals: 2,
};


export type UserStore = {
	user: User | null;
	setUser: (user: User | null) => void;
	userCurrency: UserCurrency;
	syncUserSession: (initialUser?: User | null) => Promise<User | null>;
	setIsHydrated: (state: boolean) => void;
	isHydrated: boolean;
};

const resolveUserCurrency = (
	user: User | null
): UserCurrency => ({
	code: user?.app_metadata?.currency ?? DEFAULT_USER_CURRENCY.code,
	symbol: user?.app_metadata?.currency_symbol ?? DEFAULT_USER_CURRENCY.symbol,
	decimals: user?.app_metadata?.decimal ?? DEFAULT_USER_CURRENCY.decimals,
});

export const createUserSlice: StateCreator<UserStore> = (set) => ({
	user: null,
	setUser: (user) =>
		set({
			user,
			userCurrency: resolveUserCurrency(user),
	}),
	userCurrency: DEFAULT_USER_CURRENCY,
	isHydrated: false,
	setIsHydrated: (state) => set({ isHydrated: state }),

	syncUserSession: async (initialUser) => {
		const user = initialUser ?? (await getAuthSession())?.user ?? null;

		set({
			user,
			userCurrency: resolveUserCurrency(user),
			isHydrated: true,
		});

		return user;
	},
});
